"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.phoneNumberFactory = void 0;
const Factory = require("factory.ts");
exports.phoneNumberFactory = Factory.Sync.makeFactory({
    id: Factory.each(i => i + 1),
    phone: '5555555555',
    user_id: 1,
    validated: true
});
